import { useQuery } from "@tanstack/react-query"

import { AdminPageHeader } from "@/components/AdminPageHeader"
import { DateToolbar, useKitchenDate } from "@/components/DateToolbar"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { api } from "@/lib/client"
import { formatDateLabel } from "@/lib/format"
import { queryKeys } from "@/lib/queryKeys"
import { ADMIN_TABLE_CLASSNAME, ADMIN_TABLE_HEAD_TH } from "@/lib/table"
import { cn } from "@/lib/utils"

export function KitchenPrepPage() {
  const [date, setDate] = useKitchenDate()
  const prep = useQuery({
    queryFn: () => api.kitchenPrep(date),
    queryKey: queryKeys.kitchenPrep(date),
  })
  const items = prep.data?.items ?? []
  const shortfalls = items.filter((i) => i.shortfall > 0).length

  return (
    <div>
      <AdminPageHeader
        description={`${formatDateLabel(date)} · ingredient pull vs on-hand`}
        title="Prep sheet"
      >
        <DateToolbar date={date} onChange={setDate} onPrint={() => window.print()} />
      </AdminPageHeader>
      {shortfalls > 0 ? (
        <p className="mb-4 text-sm text-amber-300">{shortfalls} items short of demand.</p>
      ) : null}
      <div className="overflow-hidden rounded-lg border border-border print-root">
        <Table className={ADMIN_TABLE_CLASSNAME}>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead className={ADMIN_TABLE_HEAD_TH}>Ingredient</TableHead>
              <TableHead className={ADMIN_TABLE_HEAD_TH}>SKU</TableHead>
              <TableHead className={`${ADMIN_TABLE_HEAD_TH} text-right`}>Need</TableHead>
              <TableHead className={`${ADMIN_TABLE_HEAD_TH} text-right`}>On hand</TableHead>
              <TableHead className={`${ADMIN_TABLE_HEAD_TH} text-right`}>Short</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {prep.isPending ? (
              <TableRow>
                <TableCell className="text-muted-foreground" colSpan={5}>
                  Loading…
                </TableCell>
              </TableRow>
            ) : items.length === 0 ? (
              <TableRow>
                <TableCell className="text-muted-foreground" colSpan={5}>
                  No ingredient demand for this date.
                </TableCell>
              </TableRow>
            ) : (
              items.map((item) => (
                <TableRow key={item.productId}>
                  <TableCell className="font-medium">{item.name}</TableCell>
                  <TableCell className="text-muted-foreground">{item.sku}</TableCell>
                  <TableCell className="text-right">
                    {item.quantity} {item.unit}
                  </TableCell>
                  <TableCell className="text-right">{item.qtyOnHand}</TableCell>
                  <TableCell
                    className={cn("text-right", item.shortfall > 0 && "font-medium text-amber-300")}
                  >
                    {item.shortfall > 0 ? item.shortfall : "—"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
